import Component from './applicant_name.vue'
export default Component
